import { isEarth } from "config";
import Coins from "assets/icons/coins.svg";
import ABCPointIcon from "assets/icons/ABCPoint.svg";

export const abcTokenName = isEarth ? "ABC Coin" : "ABC Point";

export const abcUnit = isEarth ? "ABC" : "ABCP";

export const abcLogo = isEarth ? Coins : ABCPointIcon;
